import gql from 'graphql-tag';

export default gql`
mutation {
  deleteAMExportConfig(input: {}) {
    clientMutationId
    viewer {
      id
    }
  }
}
`;
